export default {
  data: () => ({}),
};
